import keyBy from 'lodash/keyBy';
import { fromJS } from 'immutable';
import { ADD_SESSION_ITEMS } from '@instructure/quiz-common';
var addSessionItems = function addSessionItems(state, sessionItems) {
  var sessionItemsHash = keyBy(sessionItems, 'id');
  return state.mergeDeep(fromJS(sessionItemsHash));
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_SESSION_ITEMS:
      return addSessionItems(state, action.payload);
    default:
      return state;
  }
});